import config from "../../config/config";
import { getCsrfToken } from "../../public/api/authApi";
import { openScreenFetch } from "../../public/api/httpClient";
import { compressAttachmentIfImage } from "../../utils/compressImage";

const PAYMENT_BASE = `${config.BASE_URL}/payment`;

async function ensureCsrfToken() {
  let token =
    localStorage.getItem("csrf_token") || localStorage.getItem("csrf-token");
  if (!token) {
    token = await getCsrfToken();
    if (token) {
      localStorage.setItem("csrf_token", token);
      localStorage.setItem("csrf-token", token);
    }
  }
  return token;
}

export async function initiatePayment(amount) {
  await ensureCsrfToken();

  const response = await openScreenFetch(`${PAYMENT_BASE}/initiate`, {
    method: "POST",
    body: JSON.stringify({ amount }),
  });

  const data = await response.json();

  if (!response.ok && !data?.message) {
    throw new Error("Could not start payment");
  }

  return data;
}

export async function getPaymentStatus(orderId) {
  const response = await openScreenFetch(
    `${PAYMENT_BASE}/status/${encodeURIComponent(orderId)}`,
  );

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || "Could not check payment status");
  }

  return data;
}

export async function uploadPaymentProof(file) {
  if (!file) {
    throw new Error("Choose a file to upload");
  }
  await ensureCsrfToken();

  const uploadFile = await compressAttachmentIfImage(file);
  const formData = new FormData();
  formData.append("file", uploadFile);

  const response = await openScreenFetch(`${PAYMENT_BASE}/upload-proof`, {
    method: "POST",
    body: formData,
  });

  const data = await response.json();
  if (!response.ok || !data?.success) {
    const msg =
      data?.details?.proof ||
      data?.details?.attachment ||
      data?.message ||
      "Could not upload payment proof";
    throw new Error(msg);
  }

  return data.data || {};
}
